import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-org",
  "use": "icon-soc-org-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-org\">\r\n<g transform=\"translate(-113.571 -74.473) scale(1.221818)\">\r\n<path d=\"M448 128h128v128H448V128zm-224 288h128v128H224V416zm448 0h128v128H672V416zM448 704h128v128H448V704z\" />\r\n  <path d=\"M496 256v160H288v-48h-64v112h336V256h-64zm0 352v96h64V608H448v-48h-64v112h272V560h-64v96H512z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-org.svg
// module id = eHmF
// module chunks = 414